import React, { useState } from "react";
import { ImageAnalysisList } from "../components/medical/ImageAnalysisList";
import { ImageAnalysisDetail } from "../components/medical/ImageAnalysisDetail";

export default function Images() {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedAnalysisId, setSelectedAnalysisId] = useState<string | null>(null);

  const handleSearchChange = (query: string) => {
    setSearchQuery(query);
  };

  const handleAnalysisSelect = (id: string) => {
    setSelectedAnalysisId(id);
  };

  return (
    <div className="flex h-full overflow-hidden">
      <ImageAnalysisList
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
        selectedAnalysisId={selectedAnalysisId}
        onAnalysisSelect={handleAnalysisSelect}
      />
      <ImageAnalysisDetail analysisId={selectedAnalysisId} />
    </div>
  );
} 